import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { useStore } from '../../contexts/StoreContext';
import { priceBudgets } from '../../data/options';
export function HeroSearch() {
  const {
    brands,
    vehicles
  } = useStore();
  const navigate = useNavigate();
  const [brand, setBrand] = useState('');
  const [model, setModel] = useState('');
  const [version, setVersion] = useState('');
  const [budget, setBudget] = useState(0);
  const published = useMemo(() => vehicles.filter(v => v.published), [vehicles]);
  const models = useMemo(() => Array.from(new Set(published.filter(v => !brand || v.brandId === brand).map(v => v.model))).sort(), [published, brand]);
  const versions = useMemo(() => published.filter(v => (!brand || v.brandId === brand) && v.model === model), [published, brand, model]);
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (version) {
      navigate(`/vehiculo/${version}`);
      return;
    }
    const p = new URLSearchParams();
    if (brand) p.set('brand', brand);
    if (model) p.set('model', model);
    if (budget) p.set('maxPrice', String(budget));
    navigate(`/catalogo${p.toString() ? `?${p}` : ''}`);
  };
  return <form onSubmit={onSubmit} className="rounded-2xl border border-line bg-surface/95 p-3 backdrop-blur sm:p-4" aria-label="Buscador de 0 km" data-id="element-735" data-mp="352rkba9toyld">
      <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-[1fr_1fr_1fr_1fr_auto]" data-id="element-736" data-mp="3stng0ihegdxw">
        <div data-id="element-737" data-mp="1m18ufvh1tca">
          <label htmlFor="hs-brand" className="label" data-id="element-738" data-mp="1onci4f8rop8">Marca</label>
          <select id="hs-brand" className="input" value={brand} onChange={e => {
          setBrand(e.target.value);
          setModel('');
          setVersion('');
        }} data-id="element-739" data-mp="3j2aojrzijpse">
            <option value="" data-id="element-740" data-mp="3nzsowtzgswos">Todas</option>
            {brands.map(b => <option key={b.id} value={b.id} data-id="element-741" data-mp="fl0wplb5u47e">{b.name}</option>)}
          </select>
        </div>
        <div data-id="element-742" data-mp="kf558902qkal">
          <label htmlFor="hs-model" className="label" data-id="element-743" data-mp="u92adaweacvp">Modelo</label>
          <select id="hs-model" className="input" value={model} onChange={e => {
          setModel(e.target.value);
          setVersion('');
        }} data-id="element-744" data-mp="u8itzyme7wjs">
            <option value="" data-id="element-745" data-mp="l8chog2fl2m7">Todos</option>
            {models.map(m => <option key={m} value={m} data-id="element-746" data-mp="l6jcl57guqgb">{m}</option>)}
          </select>
        </div>
        <div data-id="element-747" data-mp="g8zxy46uwbnu">
          <label htmlFor="hs-version" className="label" data-id="element-748" data-mp="gbm1lsqmm70s">Versión</label>
          <select id="hs-version" className="input" value={version} onChange={e => setVersion(e.target.value)} disabled={!model} data-id="element-749" data-mp="bbr9xmz11deo">
            <option value="" data-id="element-750" data-mp="6hn6hdoyznic">{model ? 'Todas' : 'Elegí un modelo'}</option>
            {versions.map(v => <option key={v.id} value={v.id} data-id="element-751" data-mp="3tofpcltjmraj">{v.version}</option>)}
          </select>
        </div>
        <div data-id="element-752" data-mp="3opm9imqsao77">
          <label htmlFor="hs-budget" className="label" data-id="element-753" data-mp="3oo1g50g7hbax">Presupuesto</label>
          <select id="hs-budget" className="input" value={budget} onChange={e => setBudget(Number(e.target.value))} data-id="element-754" data-mp="3jq9qkd31a19w">
            <option value={0} data-id="element-755" data-mp="1z8qqivty8ghl">Sin tope</option>
            {priceBudgets.map(b => <option key={b.value} value={b.value} data-id="element-756" data-mp="246iskiob5izi">{b.label}</option>)}
          </select>
        </div>
        <button type="submit" className="btn btn-primary col-span-2 self-end lg:col-span-1 lg:px-6" data-id="element-757" data-mp="2976jz5gg81u9">
          <SearchIcon className="h-4 w-4" aria-hidden data-id="element-758" data-mp="2d6p5o3g3ggy5" />
          Buscar
        </button>
      </div>
    </form>;
}